import { Component, OnInit, SecurityContext, Output, EventEmitter, Input } from "@angular/core";
import { ExamsService } from "../exams.service";
import { PatientsService } from "../patients.service";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { TranslateService } from "@ngx-translate/core";
import { PdfprintService } from "../pdfprint.service";
import { LoginService } from "../login.service";
import { StatsService } from "../stats.service";
import { SignatureService } from "../signature.service";

@Component({
    selector: "app-printopts",
    templateUrl: "./printopts.component.html",
    styleUrls: ["./printopts.component.scss"],
    standalone: false
})
export class PrintoptsComponent implements OnInit {
  @Output() closed = new EventEmitter<string>();
  @Input("showopts") ShowOptions: boolean;
  @Input("stats") stats: boolean = false;
  @Input("isReport") isReport: boolean = false;
  @Input("type") type: string = "";
  @Input("startdate") startdate: Date;
  @Input("enddate") enddate: Date;
  @Input("hmostype") hmostype: string = "";
  @Input("signature") signature = false;

  showlast: boolean;
  lang: string = "en-US";
  link = "";
  chameleon = false;

  pdfToShow: SafeResourceUrl = null;
  isPDFLoading = false;
  showGallery = true;

  lastLink: string = "";
  showGo = true;
  tabMemory: boolean;
  changeTitle = false;
  newTitle: any;

  public isPreviewGenerated: boolean = false;
  public disableNewTab: boolean = false;
  private showLast: boolean;

  constructor(
    public sts: StatsService,
    public examService: ExamsService,
    private pat: PatientsService,
    private sanitizer: DomSanitizer,
    private translate: TranslateService,
    public pdf: PdfprintService,
    public login: LoginService,
    public signatureService: SignatureService
  ) {
    this.lang = this.translate.currentLang;
    if (this.login.printLang) this.pdf.Lang = this.login.printLang;
    if (this.login.printStyle) this.pdf.Style = this.login.printStyle;
    //this.getImageFromService();
    //this.link=this.sanitizer.sanitize(SecurityContext.URL,  '/api/printpdf/'+this.examservice.examID+'/'+this.pat.currentPatient.PID+'/'+this.lang);
  }

  ngOnInit() {
    const isExamSigned = this.signatureService.isExamSigned(this.examService.examObject);

    this.pdf.printCharts = false;
    this.pdf.printImages = false;

    if (this.examService.isClosed && this.login.hasChameleon) {
      this.chameleon = true;
    }

    if (!this.login.letterhead) {
      this.pdf.letterhead = false;
    }

    // Exam Is Closed/Signed:
    if (this.examService.isClosed && (!this.ShowOptions || !this.examService.PregCopied)) {
      this.ShowOptions = false;
      this.showLast = true;
      this.tabMemory = this.pdf.newTab;
      this.pdf.newTab = false;
      this.getPDF();
    }

    // Exam Is Open/Unsigned:
    if (!isExamSigned) {
      this.ShowOptions = true;
      this.showLast = false;
      this.tabMemory = this.pdf.newTab;
      this.signature ? (this.disableNewTab = true) : (this.disableNewTab = false);
      this.signature ? (this.pdf.newTab = false) : (this.pdf.newTab = true);
      this.isPreviewGenerated = false;
    }

    // Exam Is Closed/Signed and Yes+Print:
    if (isExamSigned && this.examService.isSignAndPrint) {
      this.ShowOptions = true;
      this.tabMemory = this.pdf.newTab;
      this.pdf.newTab = false;
      this.getPDF("y");
    } else {
      this.pdf.printCharts = false;
      this.pdf.printImages = false;
    }
    // Old signature style
    // if (!this.examService.signed) {
    //   this.pdf.Lang = this.login.printLang;
    //   this.tabMemory = this.pdf.newTab;

    //   this.pdf.newTab = false;
    //   this.getPDF("preview");
    // }

    // Load existing changed title if exists
    if (this.examService.changedTitle && this.examService.newTitle) {
      this.changeTitle = this.examService.changedTitle;
      this.newTitle = this.examService.newTitle;
    }
    
    // Ensure CustomTitles are loaded
    if (!this.examService.CustomTitles || this.examService.CustomTitles.length === 0) {
      this.examService.getCustomTitles();
    }
  }

  getImageFromService() {
    this.showGo = false;
    this.pdf.getPDF(this.examService.examID, this.pat.currentPatient.PID).subscribe(
      (data) => {
        this.createPDFFromBlob(data);
        this.isPDFLoading = false;
        this.showGo = true;
      },
      (error) => {
        this.isPDFLoading = false;
        console.log(error);
      }
    );
    if (this.showlast) {
      this.showlast = false;
      this.pdf.newTab = this.tabMemory;
      this.showGallery = true;
    }
  }

  getPDF(printReturnVal: string = null) {
    const isExamSigned = this.signatureService.isExamSigned(this.examService.examObject);

    if (!this.examService.isClosed) {
      // If user selected "Use Default Title" or no title, reset the changed title
      if (!this.newTitle || !this.changeTitle) {
        this.examService.changedTitle = false;
        this.examService.changeTitle("", false);
      } else {
        // User selected a custom title
        this.examService.changedTitle = this.changeTitle;
        this.examService.changeTitle(this.newTitle);
      }
    }
    if (printReturnVal && !this.stats) {
      this.isPreviewGenerated = isExamSigned && this.examService.isSignAndPrint ? false : true;
      this.ShowOptions = false;
      this.pdf.returnval = printReturnVal;
    } else {
      this.pdf.returnval = this.examService.isClosed ? "view" : "y";
      if (this.showlast) {
        this.pdf.returnval = "last";
      }
    }
    this.isPDFLoading = true;
    this.showGallery = false;
    if (
      !this.stats &&
      this.lastLink ==
        this.examService.examID +
          "/" +
          this.pat.currentPatient.PID +
          "/" +
          this.pdf.Lang +
          "/" +
          (this.pdf.printCharts ? "y" : "n") +
          "/" +
          (this.pdf.printImages ? "y" : "n") +
          "/" +
          this.pdf.Style +
          "/" +
          this.pdf.perPage +
          "/" +
          this.pdf.returnval +
          "/" +
          (this.pdf.letterhead ? "y" : "n") +
          "/n"
    ) {
      //to prevent trying to load mutiple times
      return;
    }
    if (!this.stats)
      this.lastLink =
        this.examService.examID +
        "/" +
        this.pat.currentPatient.PID +
        "/" +
        this.pdf.Lang +
        "/" +
        (this.pdf.printCharts ? "y" : "n") +
        "/" +
        (this.pdf.printImages ? "y" : "n") +
        "/" +
        this.pdf.Style +
        "/" +
        this.pdf.perPage +
        "/" +
        this.pdf.returnval +
        "/" +
        (this.pdf.letterhead ? "y" : "n") +
        "/n";
    if (this.pdf.newTab || this.stats) {
      if (this.stats && !this.isReport) {
        this.pdf.returnval = "y";
        var temp =
          "api/print/" +
          this.pdf.Lang +
          "/" +
          this.pdf.Style +
          "/" +
          this.pdf.returnval +
          "/" +
          this.sts.Params.type;
        if (this.sts.Params["date"]) {
          temp += "/months/" + this.sts.Params["date"] + "/n" + "/" + this.sts.Params["searchByType"];
        } else {
          temp +=
            "/dates/" +
            this.sts.Params["start"] +
            "/" +
            this.sts.Params["end"] +
            "/" +
            this.sts.Params["searchByType"];
        }
        // console.log(temp);

        window.open(temp);
      } else if (this.stats && this.isReport) {
        this.pdf.returnval = "y";
        var start = new Date(this.startdate.toISOString().split("T")[0]);
        var end = new Date(this.enddate.toISOString().split("T")[0]);
        var temp =
          "api/print/" +
          (this.isReport ? "y" : "n") +
          "/" +
          this.type +
          "/" +
          this.startdate.toISOString().split("T")[0] +
          "/" +
          this.enddate.toISOString().split("T")[0] +
          "/" +
          this.hmostype;
        window.open(temp);
      } else {
        window.open(
          "api/printpdf/" +
            this.examService.examID +
            "/" +
            this.pat.currentPatient.PID +
            "/" +
            this.pdf.Lang +
            "/" +
            (this.pdf.printCharts ? "y" : "n") +
            "/" +
            (this.pdf.printImages ? "y" : "n") +
            "/" +
            this.pdf.Style +
            "/" +
            this.pdf.perPage +
            "/" +
            this.pdf.returnval +
            "/" +
            (this.pdf.letterhead ? "y" : "n") +
            "/n"
        );
      }
      this.isPDFLoading = false;
      this.closed.emit(null);
    } else {
      this.getImageFromService();
    }
  }

  createPDFFromBlob(pdf: ArrayBuffer) {
    let file = new Blob([pdf], { type: "application/pdf" });
    this.pdfToShow = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(file));
  }

  setLink() {
    this.link = "";
    this.link = this.sanitizer.sanitize(
      SecurityContext.URL,
      "/api/printpdf/" + this.examService.examID + "/" + this.pat.currentPatient.PID + "/" + this.lang
    );
  }

  resendChameleon() {
    this.pdf.resendChameleon(this.examService.examID, this.pat.currentPatient.PID).subscribe(
      (data) => {},
      (error) => {
        console.log(error);
      }
    );
    this.chameleon = false;
  }

  handleSignAndPrint() {
    this.examService.isSignAndPrint = true;
    this.closed.emit("signShowPrint");
  }

  handleSign() {
    this.examService.isSignAndPrint = false;
    this.closed.emit("sign");
  }
}
